import { Drawer } from '@chakra-ui/react';

import { useProfileDrawer } from '../useProfileDrawer';
import { Footer } from './Footer';
import { ProfileCard } from './ProfileCard';
import { TokenList } from './TokenList';
import { TokenListTabs } from './TokenListTabs';

export const DefaultContent = () => {
  return (
    <>
      <Drawer.Body
        ref={(elem) => {
          useProfileDrawer.setState({
            _drawerBodyElement: elem,
          });
        }}
        pt="0"
        px="0"
      >
        <ProfileCard mx="20px" mt="24px" />
        <TokenListTabs
          pt="8px"
          position="sticky"
          top="-1px"
          bg="background.offWhite"
          zIndex="1"
        />
        <TokenList />
      </Drawer.Body>
      <Footer />
    </>
  );
};
